import { gql } from "@apollo/client";

export const GET_TIER = gql`
  query GetTier {
    onTrialUntil
    tier
    tierFeatures
  }
`;
